<template>
  <!-- 연관검색어 리스트 -->
  <div ref="relatedKeywordList" class="wrap_search related_keyword">
    <ul v-if="dataAutoCorsList.length > 0" >
      <li
        v-for="(item, index) in dataAutoCorsList"
        :key="index"
      >
        <button
          class="btn_related_keyword"
          @click.stop="onKeywordClick(item.name)"
        >
          <span class="txt" v-html="item.nameHtml"/>
        </button>
      </li>
    </ul>
    <ul v-else>
      <li class="no_list" >
        <span class="txt">해당 과정이 없습니다.</span>
      </li>
    </ul>
  </div>
<!-- // 연관검색어 리스트 -->
</template>

<script>

import { debounce } from 'lodash'

export default {
  name: 'TotalSearchAutoCors',
  metaInfo () {
    return {
      title: '멀티캠퍼스 :: 통합검색'
    }
  },
  components: {
  },
  props: {
    isAuto: { // 자동완성 검색 활성화 여부
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dataAutoCorsList: [], // 자동완성 과정 목록
      searchKeyword: ''
    }
  },
  computed: {
    getSearchInput () {
      return this.$parent.searchInput
    }
  },
  watch: {
    getSearchInput: debounce(function (val) {
      val && val !== '' && this.isAuto && this.doAutoSearch(val)
    }, 500)
  },
  created () {

  },
  mounted () {
  },
  methods: {
    // 자동완성 과정 목록
    doAutoSearch (searchText) {
      if (!searchText) return

      this.dataAutoCorsList = []
      let params = {
        kwd: encodeURIComponent(searchText)
      }

      this.$http.b2c.selectSearchAutoCourses(this, params ).then( (result) => {
        if ( result && result.data && result.data.status === 'OK' ) {
          const rows = result.data.result.rows
          rows.forEach((rowItem) => {
            const kwrdNm = rowItem.fields.PRDT_NM
            const kwrdNmHtml = this.$utils.common.setReplaceAll(kwrdNm, searchText, `<em>${searchText}</em>`)
            const item = {
              'name': kwrdNm,
              'nameHtml': kwrdNmHtml
            }
            this.dataAutoCorsList.push(item)
          })
        } else {
          // 데이터 없음
        }
      })
    },
    // 과정 클릭
    onKeywordClick (val) {
      this.$emit('onKeywordClick', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/search/TotalSearchAutoCors.vue